import { ColDef } from 'ag-grid-community';
import { ITableSettings } from 'FeatureModules/DataImport/types/dataImport.types';
import { TSystemColumns } from '../Components/DataImportTable/excelTable.types';

export const DATA_IMPORT_TABLE_ROW_HEIGHT = 30;

export const VALIDATION_MESSAGE_SAME_FOCUS_CROP =
  'All focus crops need to be the same in one import.';

export const VALIDATION_MESSAGE_EMPTY =
  'Data field is required. Either delete all data from row or add missing data.';

export const DEFAULT_FARM_IMPORT_TABLE_SETTINGS: ITableSettings = {
  coordinatesVersion: 'latlng',
  farmSizeUnit: 'ha',
  weightUnit: 'kg',
};

const DEFAULT_COL_DEF: ColDef = { lockPinned: true, flex: 1, minWidth: 180 };
export const DEFAULT_COL_DEF_EDIT: ColDef = {
  ...DEFAULT_COL_DEF,
  editable: true,
};
export const DEFAULT_COL_DEF_VIEW: ColDef = {
  ...DEFAULT_COL_DEF,
  editable: false,
};

export const SYSTEM_COLUMN_DEF: ColDef<TSystemColumns> = {
  headerName: '',
  editable: false,
  width: 30,
  maxWidth: 30,
  lockPosition: true,
  resizable: false,
  suppressMovable: true,
};
